import React from 'react';
import CreateRaw from './CreateRaw'; // Assuming the path to the CreateRaw component is correct
import ViewRaw from './ViewRaw'; // Assuming the path to the ViewRaw component is correct
import RawStockIn from './RawStockIn'; // Assuming the path to the RawStockIn component is correct
import RawStockOut from './RawStockOut'; // Assuming the path to the RawStockOut component is correct

const RawList = () => {
  return (
    <div>
      <CreateRaw />
      <ViewRaw />
      <RawStockIn />
      <RawStockOut />
    </div>
  );
};

export default RawList;
